"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Controller = void 0;
const AppControllerBase_1 = require("./AppControllerBase");
const AppVX_1 = require("../AppVX");
const VControllerViewContract_1 = require("../contracts/VControllerViewContract");
const gs = require("@ivanlog/gs");
const ERC20Contract_1 = require("../contracts/ERC20Contract");
const BiMath_1 = require("../BiMath");
const VPoolContract_1 = require("../contracts/VPoolContract");
const VXContract_1 = require("../contracts/VXContract");
const VXStrategyV1Contract_1 = require("../contracts/VXStrategyV1Contract");
const VXSManagerV2Contract_1 = require("../contracts/VXSManagerV2Contract");
const CmpModalDialog_1 = require("../com/CmpModalDialog");
const PriceKeeperContract_1 = require("../contracts/PriceKeeperContract");
class Web3Controller extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._onChangeAccountToken = new gs.EventAsyncGSToken();
        this._onChangeAccount = new gs.EventAsyncGS(this._onChangeAccountToken);
    }
    get onChangeAccount() { return this._onChangeAccount; }
    get isConnected() { return this._web3 != undefined; }
    get web3() { return this._web3; }
    get account() { return this._account; }
    get vxERC20() { return this._vxERC20; }
    get vx() { return this._vx; }
    get vcontroller() { return this._vcontroller; }
    get vpool() { return this._vpool; }
    get vxstrategyV1() { return this._vxstrategyV1; }
    get vxsManagerV2() { return this._vxsManagerV2; }
    get priceKeeperPLS() { return this._priceKeeperPLS; }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initWeb3();
        });
    }
    getAccountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._account)
                return this._account;
            const result = this.refreshAccountAsync();
            return result;
        });
    }
    getChainIdAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const eth = globalThis.ethereum;
            if (!eth)
                return AppVX_1.AppVX.CHAIN_ID;
            const currentChainId = yield eth.request({ method: 'eth_chainId' });
            return currentChainId;
        });
    }
    refreshAccountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const eth = globalThis.ethereum;
            //chain validation
            const currentChainId = yield eth.request({ method: 'eth_chainId' });
            if (currentChainId != AppVX_1.AppVX.CHAIN_ID) {
                try {
                    yield eth.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: AppVX_1.AppVX.CHAIN_ID }]
                    });
                }
                catch (switchError) {
                    CmpModalDialog_1.CmpModalDialog.DialogOk("Wrong blockchain selected. Change blockchain and refresh page.").showAndWaitAsync();
                    return yield this._selectAccountAsync(undefined, new globalThis.Web3(new globalThis.Web3.providers.HttpProvider(AppVX_1.AppVX.CHAIN_RPC)));
                }
            }
            else {
                const accounts = yield eth.request({ method: 'eth_requestAccounts' });
                if (accounts.length == 0)
                    return;
                return yield this._selectAccountAsync(accounts[0], new globalThis.Web3(eth));
            }
        });
    }
    tryConnectAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const modalWalletError = CmpModalDialog_1.CmpModalDialog.DialogOk("It looks like your browser doesn't have a wallet installed. Please use a browser with a functioning MetaMask or Rabby extension", "Information");
            const modalAgreement = CmpModalDialog_1.CmpModalDialog.DialogOk("", "Information");
            modalAgreement.ctrls.lText.html = "Please confirm that you have read and agree to the <a href=\"https://up.docs.plusx.app/?folder=ValidatorX&article=Terms%20of%20Use\" target='_blank'>Terms of Use</a> by clicking the button below.";
            modalAgreement.ctrls.lText.onclick = (e) => e.stopPropagation();
            const result = yield modalAgreement.showAndWaitAsync();
            if (!result)
                return false;
            try {
                const account = yield this.getAccountAsync();
                if (!account) {
                    if (account != false)
                        modalWalletError.show();
                    return false;
                }
                return true;
            }
            catch (error) {
                modalWalletError.show();
                console.error(error);
                //throw error;
                return false;
            }
        });
    }
    _loadAccountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const eth = globalThis.ethereum;
            //chain validation
            const currentChainId = yield eth.request({ method: 'eth_chainId' });
            if (currentChainId != AppVX_1.AppVX.CHAIN_ID)
                return;
            const accounts = yield eth.request({ method: 'eth_accounts' });
            if (accounts.length == 0)
                return;
            return yield this.refreshAccountAsync();
        });
    }
    _selectAccountAsync(account, web3) {
        return __awaiter(this, void 0, void 0, function* () {
            this._account = account;
            this._web3 = web3;
            this._vxERC20.updateWeb3(this._web3);
            this._vx.updateWeb3(this._web3);
            this._vcontroller.updateWeb3(this._web3);
            this._vpool.updateWeb3(this._web3);
            this._vxstrategyV1.updateWeb3(this._web3);
            this._vxsManagerV2.updateWeb3(this._web3);
            this._priceKeeperPLS.updateWeb3(this._web3);
            yield this._onChangeAccountToken.invoke();
            if (!this._account)
                return false;
            return this._account;
        });
    }
    getBalanceEth() {
        return __awaiter(this, void 0, void 0, function* () {
            const account = this.account;
            if (!account)
                return;
            try {
                const balance = yield this._web3.eth.getBalance(account);
                return this._web3.utils.fromWei(balance, 'ether');
            }
            catch (error) { }
            return;
        });
    }
    addTokenToWalletAsync(address, symbol, decimal) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!globalThis.ethereum)
                return false;
            const eth = globalThis.ethereum;
            try {
                // 'wasAdded' is a boolean. Like any RPC method, an error can be thrown.
                const wasAdded = yield eth.request({
                    method: 'wallet_watchAsset',
                    params: {
                        type: 'ERC20',
                        options: {
                            address: address,
                            symbol: symbol,
                            decimals: decimal, // The number of decimals in the token.
                            //image: tokenImage, // A string URL of the token logo.
                        },
                    },
                });
                return wasAdded;
            }
            catch (error) {
                console.log(error);
                return false;
            }
        });
    }
    initWeb3() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._web3 = new globalThis.Web3(new globalThis.Web3.providers.HttpProvider(AppVX_1.AppVX.CHAIN_RPC));
                BiMath_1.BiMath.Init(this._web3);
                this._vcontroller = new VControllerViewContract_1.VControllerViewContract(AppVX_1.AppVX.ADDRESS_VController, this._web3);
                const vx = yield this._vcontroller.getVXAddressAsync();
                const vpool = yield this._vcontroller.getVPoolAddressAsync();
                this._vxstrategyV1 = new VXStrategyV1Contract_1.VXStrategyV1Contract(AppVX_1.AppVX.ADDRESS_VXStrategyV1, this._web3);
                this._vxsManagerV2 = new VXSManagerV2Contract_1.VXSManagerV2Contract(AppVX_1.AppVX.ADDRESS_VXSManagerV2, this._web3);
                this._vxERC20 = new ERC20Contract_1.ERC20Contract(vx, this._web3);
                this._vx = new VXContract_1.VXContract(vx, this._web3);
                this._vpool = new VPoolContract_1.VPoolContract(vpool, this._web3);
                this._priceKeeperPLS = new PriceKeeperContract_1.PriceKeeperContract(AppVX_1.AppVX.ADDRESS_PriceKeeperPLS, this._web3);
                if (window.ethereum) {
                    //Отлавливаем изменение аккаунта и обновляем аккаунт
                    window.ethereum.on('accountsChanged', (accounts) => __awaiter(this, void 0, void 0, function* () {
                        yield this.refreshAccountAsync();
                    }));
                    //Отлавливаем изменение чейна и обновляем аккаунт
                    window.ethereum.on('chainChanged', (accounts) => __awaiter(this, void 0, void 0, function* () {
                        yield this.refreshAccountAsync();
                    }));
                    yield this._loadAccountAsync();
                }
            }
            catch (e) {
                CmpModalDialog_1.CmpModalDialog.DialogOk(e).show();
            }
            yield this.app.awaitTime(2000);
        });
    }
}
exports.Web3Controller = Web3Controller;
//# sourceMappingURL=Web3Controller.js.map